<div class="flex-column gap-32">
    @if (observationResource.isLoading()) {
        <app-card preCardTitle="Cartegraph feature management">
            <div *appCardContent class="settings-header-container">
                <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
            </div>
        </app-card>
    } @else {

        <app-card preCardTitle="Cartegraph management" icon="arrow_back" (iconClicked)="navigateBack()">
            <div *appCardContent class="settings-header-container">
                <div class="settings-header-title">
                    <p>Cartegraph observations to activity mapping</p>
                    <div class="settings-header-subtitle">
                        Map PlowOps observation types to Work Task activity
                    </div>
                </div>
            </div>
        </app-card>

        @if (observationResource.value(); as groups) {
            <form [formGroup]="form">
                <div formArrayName="selections">

                    @for (group of groups; track group.id) {
                        <app-card [inCardTitle]="group.name">
                            <div *appCardContent>
                                <ng-container *ngTemplateOutlet="groupTpl;context:{group: group}"></ng-container>
                            </div>
                        </app-card>
                    }
                </div>
            </form>
        }
    }
</div>

<ng-template #groupTpl let-group="group">
    @if (activityResource.value(); as activities) {

        @for (type of group.observationTypes; track type.title) {
            <div class="field-row">
                <div class="field-row-title">
                    {{ type.title }}
                </div>
                <div class="field-row-element">
                    <app-row-with-select [list]="activities.data"
                                         listId="oid"
                                         listLabel="label"
                                         [nullLabel]="'Unset'"
                                         [formControl]="selectionsGroup.controls[group.id + '_' + type.id]"
                    >
                    </app-row-with-select>
                </div>
            </div>
        }
    }
</ng-template>
